{
  "name": "msis-inc",
  "version": "3.0.0",
  "description": "Msis Inc",
  "versionText": "versionText",
  "scripts": {
    "ng": "node ./node_modules/@angular/clie/bin/ng",
    "start": "ng serve --open  --configuration=dev",
    "start-local": "ng serve --open  --configuration=local",
    "build": "ng build",
    "build:prod": "ng build --configuration=prod",
    "build:stage": "ng build --configuration=stage",
    "build:beta": "ng build --configuration=beta",
    "build:dev": "ng build --configuration=dev",
    "build:local": "ng build --configuration=dev ",
    "test": "ng test",
    "lint": "eslint -c .eslintrc.js --ext .ts src/**",
    "e2e": "npx playwright test",
    "e2e:headed": "npx playwright test --headed",
    "e2e:ui": "npx playwright test --ui",
    "rtl": "webpack --config webpack-rtl.config.js",
    "ps": "Set-ExecutionPolicy -Scope Process -ExecutionPolicy Bypass",
    "angular-upgrade": "ng update @angular/core@18 @angular/cli@18 --force"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/localize": "^18.2.13",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@auth0/angular-jwt": "^5.2.0",
    "@azure/storage-blob": "^12.26.0",
    "@fullcalendar/core": "^6.1.15",
    "@syncfusion/ej2-angular-base": "28.1.33",
    "@syncfusion/ej2-angular-buttons": "28.1.33",
    "@syncfusion/ej2-angular-dropdowns": "28.1.33",
    "@syncfusion/ej2-angular-filemanager": "28.1.33",
    "@syncfusion/ej2-angular-inputs": "28.1.33",
    "@syncfusion/ej2-angular-navigations": "28.1.33",
    "@syncfusion/ej2-angular-popups": "28.1.33",
    "@syncfusion/ej2-angular-splitbuttons": "28.1.33",
    "@syncfusion/ej2-base": "28.1.33",
    "@syncfusion/ej2-buttons": "28.1.33",
    "@syncfusion/ej2-data": "28.1.33",
    "@syncfusion/ej2-dropdowns": "28.1.33",
    "@syncfusion/ej2-filemanager": "28.1.33",
    "@syncfusion/ej2-inputs": "28.1.33",
    "@syncfusion/ej2-navigations": "28.1.33",
    "@syncfusion/ej2-popups": "28.1.33",
    "@syncfusion/ej2-splitbuttons": "28.1.33",
    "@twilio/voice-sdk": "^2.12.3",
    "angular-jwt": "^0.1.11",
    "bootstrap": "^5.3.3",
    "file-saver": "^2.0.5",
    "global": "^4.4.0",
    "howler": "^2.2.4",
    "ical.js": "^2.1.0",
    "ics": "^3.8.1",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ng2-pdfjs-viewer": "^18.0.0",
    "ngx-cookie-service": "^18.0.0",
    "ngx-image-zoom": "^3.0.0",
    "ngx-img-zoom": "^4.1.2",
    "ngx-logger": "^5.0.12",
    "ngx-mask": "^17.1.8",
    "perfect-scrollbar": "^1.5.5",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "^17.18.15",
    "process": "^0.11.10",
    "quill": "2.0.2",
    "rxjs": "^7.8.1",
    "signature_pad": "^5.0.2",
    "tslib": "^2.6.3",
    "tui-calendar": "^1.15.3",
    "twilio-client": "^1.15.1",
    "util": "^0.12.5",
    "xlsx": "^0.18.5",
    "zone.js": "^0.14.7"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.14",
    "@angular-eslint/builder": "18.4.3",
    "@angular-eslint/eslint-plugin": "^18.4.3",
    "@angular-eslint/eslint-plugin-template": "^18.4.3",
    "@angular-eslint/schematics": "18.0.1",
    "@angular-eslint/template-parser": "18.0.1",
    "@angular/cli": "^18.2.14",
    "@angular/compiler-cli": "^18.2.13",
    "@angularclass/hmr": "^3.0.0",
    "@playwright/test": "^1.58.2",
    "@types/lodash": "^4.17.15",
    "@types/node": "^20.17.16",
    "@typescript-eslint/eslint-plugin": "^8.22.0",
    "@typescript-eslint/parser": "^7.18.0",
    "codelyzer": "^6.0.2",
    "cpx": "^1.5.0",
    "eslint": "^9.19.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-angular": "^4.1.0",
    "eslint-plugin-css-modules": "^2.12.0",
    "eslint-plugin-html": "^8.1.1",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsdoc": "^48.11.0",
    "eslint-plugin-json": "^4.0.0",
    "eslint-plugin-node": "^11.1.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-rxjs": "^5.0.3",
    "gzipper": "^7.2.0",
    "pdfjs-dist": "^4.10.38",
    "prettier": "3.3.3",
    "prettier-eslint": "^16.3.0",
    "prettier-stylelint": "^0.4.2",
    "pretty-quick": "^4.0.0",
    "protractor": "^7.0.0",
    "ts-cacheable": "^1.0.10",
    "ts-node": "^10.9.2",
    "typescript": "5.5.4",
    "webpack-cli": "^6.0.1",
    "webpack-messages": "^2.0.4"
  },
  "husky": {
    "hooks": {
      "pre-commit": "lint-staged"
    }
  },
  "lint-staged": {
    "*.{ts,js,json,scss,md,html}": [
      "git add"
    ]
  },
  "cli": {
    "packageManager": "yarn"
  },
  "packageManager": "yarn@4.2.2"
}
